import { useFormState } from 'react-final-form'
import { DurationStepField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

const wrappedInputProps = {
  step: 10,
  min: 0,
  max: 23 * 60 + 59,
}

function secToMin(seconds: number) {
  return Math.round(seconds / 60)
}

function minToSec(minutes: number) {
  return minutes * 60
}

export function PreparationTime() {
  const texts = useTexts()

  const {
    values: { departureDepotId },
  } = useFormState()

  if (departureDepotId === 'disabledDepotValue') return null

  return (
    <DurationStepField
      name="preparationTimeSec"
      testid="preparationTime"
      half
      info={texts.preparationTimeInfo}
      label={texts.preparationTime}
      parse={minToSec}
      format={secToMin}
      wrappedInputProps={wrappedInputProps}
    />
  )
}
